import { render } from "./InvitationCard.vue?vue&type=template&id=2735db8f&scoped=true"
import script from "./InvitationCard.vue?vue&type=script&lang=js"
export * from "./InvitationCard.vue?vue&type=script&lang=js"

import "./InvitationCard.vue?vue&type=style&index=0&id=2735db8f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2735db8f"]])

export default __exports__